export default {
      id: "icon-arrow-left-usage",
      viewBox: "0 0 20 12",
      url: __webpack_public_path__ + "icons.svg#icon-arrow-left",
      toString: function () {
        return this.url;
      }
    }